module.exports = __webpack_public_path__ + "static/illustration_resources-0abda72d692f4a32c86a9e8e0b792694.png";